import { IHoliday } from 'src/app/setting/holiday/model/holiday';

// Holiday whose start day equals the given date (same day-level match the slot colouring uses).
export function findHoliday(holidays: IHoliday[], date: Date): IHoliday | undefined {
  const day = date.toDateString();
  return (holidays ?? []).find(holiday => new Date(holiday.start).toDateString() === day);
}
